import { config } from '../../utils/utils';
import store from '../../store';
import { toastHandler } from '../../utils/toastHandler';

export interface CompanyListItem {
  id: string;
  name: string;
  email: string;
  mobileNumber?: string;
  countryCallingCode?: string;
  activeState?: boolean;
}

export interface CompaniesListResponse {
  total: number;
  limit: number;
  skip: number;
  data: CompanyListItem[];
}

/**
 * Get companies list (for admin)
 */
export const getCompaniesList = async (
  options?: { limit?: number; skip?: number; search?: string }
): Promise<CompaniesListResponse> => {
  try {
    const { accessToken } = store.getState().auth;

    let url = `${config.BASE_URL}/companies-list`;
    const params = new URLSearchParams();

    if (options?.limit !== undefined) {
      params.append('limit', options.limit.toString());
    }
    if (options?.skip !== undefined) {
      params.append('skip', options.skip.toString());
    }
    if (options?.search) {
      params.append('search', options.search);
    }

    const queryString = params.toString();
    if (queryString) {
      url = `${url}?${queryString}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch companies list');
    }

    return await response.json();
  } catch (error: any) {
    toastHandler(error);
    throw error;
  }
};

